import { parseTema } from "../utils/utilerias";
import "../styles/TemaItem.css";

export function TemaItem({ tema, calificacion, fontColor, numero, codigo, user }) {
  //const { titulo, url, codigo, flags } = parseTema(rawValue);
  //console.log("User en TemaItem: ", user);

  if (!tema) return null;
  return (
    <div className="tema-item" style={{ borderLeft: `4px solid ${fontColor}` }}>
      <div className="tema-icono">
        <img
          src={`/icons/${tema.icono}.png`}
          alt={tema.icono}
          style={{ filter: calificacion < 7 ? "grayscale(100%)" : "none" }}
        />
      </div>
      <div className="tema-info">
        <span className="tema-titulo">{numero}. {tema.titulo} {user.rol === "ROOT" &&
          (<strong>
            ({codigo})
          </strong>)
        }</span>

      </div>
      <div className="tema-calificacion">
        {calificacion !== null ? (
          <span>
            {calificacion >= 9 ? "Excelente 🏅" : calificacion == 8 ? "Muy bien🥈" : calificacion == 7 ? "Bien🥉" : "No aprobado ❌"}
            Cal: {calificacion}{" "}
          </span>
        ) : (
          <span>Pendiente</span>
        )}
      </div>
    </div >
  );
}

export default TemaItem;
